// // components/user/ZambiaAuthorities.jsx
// import React, { useState, useEffect } from 'react';
// import { FaCheckCircle, FaClock, FaBuilding, FaFileContract, FaBalanceScale } from 'react-icons/fa';
// import { getZambiaAuthorities } from '../../utils/api';

// const ZambiaAuthorities = ({ certifications = [] }) => {
//   const [authorities, setAuthorities] = useState([]);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     loadAuthorities();
//   }, []);

//   const loadAuthorities = async () => {
//     try {
//       const response = await getZambiaAuthorities();
//       const authoritiesData = response.data || [];
//       setAuthorities(authoritiesData);
//     } catch (error) {
//       console.error('Error loading Zambia authorities:', error);
//       // Use default authorities if API fails
//       setAuthorities([
//         { acronym: 'PACRA', name: 'Patents and Company Registration Agency', description: 'Company registration and intellectual property' },
//         { acronym: 'ZRA', name: 'Zambia Revenue Authority', description: 'Tax compliance and registration' },
//         { acronym: 'ZPPA', name: 'Zambia Public Procurement Authority', description: 'Public procurement registration' },
//         { acronym: 'NCC', name: 'National Council For Construction', description: 'Construction industry registration' },
//         { acronym: 'WCFCB', name: 'Workers\' Compensation Fund Control Board', description: 'Workers compensation compliance' },
//         { acronym: 'NAPSA', name: 'National Pension Scheme Authority', description: 'Pension scheme compliance' },
//       ]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const getAuthorityStatus = (acronym) => {
//     const hasCert = certifications.some(cert => 
//       (cert.authority_acronym || cert.issuing_authority) === acronym
//     );
    
//     return {
//       hasCert,
//       status: hasCert ? 'registered' : 'pending',
//       icon: hasCert ? <FaCheckCircle className="h-5 w-5 text-green-500" /> : <FaClock className="h-5 w-5 text-amber-500" />,
//       color: hasCert ? 'green' : 'amber',
//       text: hasCert ? 'Registered' : 'Compliant'
//     };
//   };

//   const getAuthorityIcon = (acronym) => {
//     const icons = {
//       'PACRA': <FaBuilding className="h-6 w-6" />,
//       'ZRA': <FaBalanceScale className="h-6 w-6" />,
//       'ZPPA': <FaFileContract className="h-6 w-6" />,
//       'NCC': <FaBuilding className="h-6 w-6" />,
//       'WCFCB': <FaCheckCircle className="h-6 w-6" />,
//       'NAPSA': <FaCheckCircle className="h-6 w-6" />,
//     };
//     return icons[acronym] || <FaFileContract className="h-6 w-6" />;
//   };

//   if (loading) {
//     return (
//       <div className="bg-gradient-to-b from-blue-50 to-white py-12">
//         <div className="container-custom">
//           <div className="text-center">
//             <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-100 rounded-full mb-4 animate-pulse">
//               <div className="h-8 w-8 bg-blue-200 rounded"></div>
//             </div>
//             <div className="h-8 bg-blue-100 rounded w-64 mx-auto mb-4 animate-pulse"></div>
//             <div className="h-4 bg-blue-100 rounded w-96 mx-auto mb-8 animate-pulse"></div>
//           </div>
//           <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
//             {[...Array(6)].map((_, i) => (
//               <div key={i} className="bg-white rounded-xl p-4 shadow-sm animate-pulse">
//                 <div className="h-12 w-12 bg-gray-200 rounded-full mx-auto mb-3"></div>
//                 <div className="h-4 bg-gray-200 rounded w-3/4 mx-auto mb-2"></div>
//                 <div className="h-3 bg-gray-200 rounded w-1/2 mx-auto"></div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="bg-gradient-to-b from-blue-50 to-white py-12 md:py-16">
//       <div className="container-custom">
//         <div className="text-center mb-10 md:mb-12">
//           <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-r from-blue-600 to-blue-800 rounded-full mb-4 shadow-lg">
//             <FaBalanceScale className="h-8 w-8 text-white" />
//           </div>
//           <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
//             Registered & Certified in Zambia
//           </h2>
//           <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto">
//             Fully compliant with all Zambian regulatory authorities and government agencies
//           </p>
//         </div>
        
//         <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-6 mb-10 md:mb-12">
//           {authorities.map((authority) => {
//             const status = getAuthorityStatus(authority.acronym);
            
//             return (
//               <div 
//                 key={authority.acronym} 
//                 className={`group relative bg-white rounded-xl p-4 md:p-5 shadow-sm hover:shadow-lg transition-all duration-300 border-2 ${
//                   status.hasCert 
//                     ? 'border-green-200 hover:border-green-300' 
//                     : 'border-gray-200 hover:border-amber-200'
//                 }`}
//               >
//                 {/* Status Dot */}
//                 <div className={`absolute top-2 right-2 w-3 h-3 rounded-full ${
//                   status.hasCert ? 'bg-green-500' : 'bg-amber-500'
//                 }`}></div>
                
//                 {/* Authority Icon */}
//                 <div className={`flex items-center justify-center w-12 h-12 md:w-14 md:h-14 rounded-full mx-auto mb-3 md:mb-4 ${
//                   status.hasCert 
//                     ? 'bg-gradient-to-br from-green-50 to-green-100 text-green-600' 
//                     : 'bg-gradient-to-br from-amber-50 to-amber-100 text-amber-600'
//                 }`}>
//                   {getAuthorityIcon(authority.acronym)}
//                 </div>
                
//                 {/* Authority Name */}
//                 <div className="text-center">
//                   <div className={`font-bold text-lg md:text-xl mb-1 ${
//                     status.hasCert ? 'text-gray-800' : 'text-gray-600'
//                   }`}>
//                     {authority.acronym}
//                   </div>
//                   <div className={`text-xs md:text-sm mb-2 ${
//                     status.hasCert ? 'text-green-600 font-semibold' : 'text-amber-600'
//                   }`}>
//                     {status.text}
//                   </div>
//                   <div className="text-xs text-gray-500 line-clamp-2">
//                     {authority.name}
//                   </div>
//                 </div>
                
//                 {/* Hover Overlay */}
//                 <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-center p-4">
//                   <div className="text-white text-center">
//                     <div className="text-xs font-medium mb-1">Status</div>
//                     <div className="flex items-center justify-center gap-1">
//                       {status.icon}
//                       <span className="text-sm font-semibold">{status.text}</span>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             );
//           })}
//         </div>
        
//         {/* Compliance Statement */}
//         <div className="bg-gradient-to-r from-blue-600 to-blue-800 rounded-2xl p-6 md:p-8 text-white text-center shadow-lg">
//           <div className="max-w-4xl mx-auto">
//             <h3 className="text-2xl md:text-3xl font-bold mb-4">
//               Regulatory Compliance Excellence
//             </h3>
//             <p className="text-lg md:text-xl text-blue-100 mb-6">
//               Brasotech Investments Limited maintains full compliance with all Zambian regulatory requirements, 
//               ensuring legal operation and adherence to the highest standards of business practice.
//             </p>
//             <div className="flex flex-col sm:flex-row gap-4 justify-center">
//               <a 
//                 href="/certifications" 
//                 className="inline-flex items-center justify-center bg-white text-blue-600 px-6 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors duration-200"
//               >
//                 View All Certificates
//                 <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
//                 </svg>
//               </a>
//               <a 
//                 href="/contact" 
//                 className="inline-flex items-center justify-center bg-transparent border-2 border-white text-white px-6 py-3 rounded-lg font-semibold hover:bg-white/10 transition-colors duration-200"
//               >
//                 Request Verification
//                 <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
//                 </svg>
//               </a>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ZambiaAuthorities;


// src/components/user/ZambiaAuthorities.jsx
import React, { useState, useEffect } from 'react';
import { FaCheckCircle, FaClock, FaBuilding, FaFileContract, FaBalanceScale } from 'react-icons/fa';
import { getZambiaAuthorities } from '../../utils/api';

const ZambiaAuthorities = () => {
  const [authorities, setAuthorities] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadAuthorities();
  }, []);

  const loadAuthorities = async () => {
    try {
      const response = await getZambiaAuthorities();
      const authoritiesData = response.data || [];
      setAuthorities(authoritiesData);
    } catch (error) {
      console.error('Error loading Zambia authorities:', error);
      // Use default authorities if API fails
      setAuthorities([
        { acronym: 'PACRA', name: 'Patents and Company Registration Agency', description: 'Company registration and intellectual property' },
        { acronym: 'ZRA', name: 'Zambia Revenue Authority', description: 'Tax compliance and registration' },
        { acronym: 'ZPPA', name: 'Zambia Public Procurement Authority', description: 'Public procurement registration' },
        { acronym: 'NCC', name: 'National Council For Construction', description: 'Construction industry registration' },
        { acronym: 'WCFCB', name: 'Workers\' Compensation Fund Control Board', description: 'Workers compensation compliance' },
        { acronym: 'NAPSA', name: 'National Pension Scheme Authority', description: 'Pension scheme compliance' },
      ]);
    } finally {
      setLoading(false);
    }
  };

  const getAuthorityIcon = (acronym) => {
    const icons = {
      'PACRA': <FaBuilding className="h-6 w-6" />,
      'ZRA': <FaBalanceScale className="h-6 w-6" />,
      'ZPPA': <FaFileContract className="h-6 w-6" />,
      'NCC': <FaBuilding className="h-6 w-6" />,
      'WCFCB': <FaCheckCircle className="h-6 w-6" />,
      'NAPSA': <FaCheckCircle className="h-6 w-6" />,
    };
    return icons[acronym] || <FaFileContract className="h-6 w-6" />;
  };

  if (loading) {
    return (
      <div className="bg-gradient-to-b from-blue-50 to-white py-12">
        <div className="container-custom">
          <div className="text-center">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-100 rounded-full mb-4 animate-pulse">
              <div className="h-8 w-8 bg-blue-200 rounded"></div>
            </div>
            <div className="h-8 bg-blue-100 rounded w-64 mx-auto mb-4 animate-pulse"></div>
            <div className="h-4 bg-blue-100 rounded w-96 mx-auto mb-8 animate-pulse"></div>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
            {[...Array(6)].map((_, i) => (
              <div key={i} className="bg-white rounded-xl p-4 shadow-sm animate-pulse">
                <div className="h-12 w-12 bg-gray-200 rounded-full mx-auto mb-3"></div>
                <div className="h-4 bg-gray-200 rounded w-3/4 mx-auto mb-2"></div>
                <div className="h-3 bg-gray-200 rounded w-1/2 mx-auto"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-gradient-to-b from-blue-50 to-white py-12 md:py-16">
      <div className="container-custom">
        <div className="text-center mb-10 md:mb-12">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-r from-blue-600 to-blue-800 rounded-full mb-4 shadow-lg">
            <FaBalanceScale className="h-8 w-8 text-white" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
            Registered & Certified in Zambia
          </h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto">
            Fully compliant with all Zambian regulatory authorities and government agencies
          </p>
        </div>
        
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-6 mb-10 md:mb-12">
          {authorities.map((authority) => (
            <div 
              key={authority.acronym} 
              className="group relative bg-white rounded-xl p-4 md:p-5 shadow-sm hover:shadow-lg transition-all duration-300 border-2 border-green-200 hover:border-green-300"
            >
              {/* Status Dot */}
              <div className="absolute top-2 right-2 w-3 h-3 rounded-full bg-green-500"></div>
              
              {/* Authority Icon */}
              <div className="flex items-center justify-center w-12 h-12 md:w-14 md:h-14 rounded-full mx-auto mb-3 md:mb-4 bg-gradient-to-br from-green-50 to-green-100 text-green-600">
                {getAuthorityIcon(authority.acronym)}
              </div>
              
              {/* Authority Name */}
              <div className="text-center">
                <div className="font-bold text-lg md:text-xl mb-1 text-gray-800">
                  {authority.acronym}
                </div>
                <div className="text-xs md:text-sm mb-2 text-green-600 font-semibold">
                  Registered
                </div>
                <div className="text-xs text-gray-500 line-clamp-2">
                  {authority.name}
                </div>
              </div>
              
              {/* Hover Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-center p-4">
                <div className="text-white text-center">
                  <div className="text-xs font-medium mb-1">Status</div>
                  <div className="flex items-center justify-center gap-1">
                    <FaCheckCircle className="h-4 w-4" />
                    <span className="text-sm font-semibold">Registered</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        {/* Compliance Statement */}
        <div className="bg-gradient-to-r from-blue-600 to-blue-800 rounded-2xl p-6 md:p-8 text-white text-center shadow-lg">
          <div className="max-w-4xl mx-auto">
            <h3 className="text-2xl md:text-3xl font-bold mb-4">
              Regulatory Compliance Excellence
            </h3>
            <p className="text-lg md:text-xl text-blue-100 mb-6">
              Brasotech Investments Limited maintains full compliance with all Zambian regulatory requirements, 
              ensuring legal operation and adherence to the highest standards of business practice.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a 
                href="/certifications" 
                className="inline-flex items-center justify-center bg-white text-blue-600 px-6 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors duration-200"
              >
                Learn About Our Compliance
                <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                </svg>
              </a>
              <a 
                href="/contact" 
                className="inline-flex items-center justify-center bg-transparent border-2 border-white text-white px-6 py-3 rounded-lg font-semibold hover:bg-white/10 transition-colors duration-200"
              >
                Request Verification
                <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ZambiaAuthorities;